module.exports = __webpack_public_path__ + "img/powered-by.5314b377.png";